import React from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, SecureRoute, LoginCallback, useOktaAuth } from '@okta/okta-react';
import { Container } from 'semantic-ui-react';
import config from './config';
import Home from './Home';
import Navbar from './Navbar';
// import Profile from './Profile';

const oktaAuth = new OktaAuth(config.oidc);

const App = () => {
  const history = useHistory();
  const restoreOriginalUri = async (oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
  };
  
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <Container text style={{marginTop: '7em'}}>
        <Switch>
          <SecureRoute path="/" exact={true} component={Home}/>
          <Route path="/login/callback" component={LoginCallback}/>
          <Route
              path="/redirect/portal"
              component={() => {
              global.window && (global.window.location.href = config.redirect.redirectHomePortalUrl);
              return null;
              }}
          />
          <Route
              path="/redirect/luxury"
              component={() => {
              global.window && (global.window.location.href = config.redirect.redirectLuxuryPortalUrl);
              return null;
              }}
          />
          <Route
              path="/redirect/agent-login"
              component={() => {
              global.window && (global.window.location.href = config.redirect.redirectOtherUrl);
              return null;
              }}
          />
        </Switch>
      </Container>
    </Security>
  );
};
export default App;